export default __webpack_public_path__ + "static/media/SpaceMono.3a3a7ae0.woff2";